import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDateFeb = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("g", {
			id: `${__svgrId}-Date Icons`,
			children: /* @__PURE__ */ _jsx("g", {
				id: `${__svgrId}-Icon / Date / February`,
				children: /* @__PURE__ */ _jsxs("g", {
					id: `${__svgrId}-Icons`,
					children: [
						/* @__PURE__ */ _jsx("rect", {
							height: 24.9624,
							id: `${__svgrId}-Rectangle 61`,
							stroke: "white",
							strokeLinejoin: "round",
							strokeWidth: 2.5,
							style: { fill: "var(--sticker-pastel,#D1D7B3)" },
							width: 22.4432,
							x: 4.6789,
							y: 3.9967
						}),
						/* @__PURE__ */ _jsx("rect", {
							height: 22.4624,
							id: `${__svgrId}-Rectangle 59`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: {
								fill: "var(--sticker-pastel,#D1D7B3)",
								stroke: "var(--sticker-dark,#5F6F27)"
							},
							width: 19.9432,
							x: 5.9289,
							y: 5.2468
						}),
						/* @__PURE__ */ _jsx("rect", {
							fill: "white",
							height: 12.9712,
							id: `${__svgrId}-Rectangle 60`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#5F6F27)" },
							width: 19.9432,
							x: 5.9311,
							y: 14.7383
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M9.6541 12.8961 L9.6541 7.2961 L13.2621 7.2961 L13.2621 8.3841 L10.918 8.3841 L10.9181 9.4561 L13.0141 9.4561 L13.014 10.5441 L10.918 10.5441 L10.918 12.8961 L9.6541 12.8961 Z M13.7147 12.8961 L13.7146 7.2961 L17.3947 7.2962 L17.3947 8.3842 L14.9787 8.3841 L14.9786 9.4002 L17.0186 9.4001 L17.0186 10.4881 L14.9787 10.4882 L14.9787 11.8081 L17.3947 11.8082 L17.3946 12.8961 L13.7147 12.8961 Z M17.9628 12.8961 L17.9628 7.2962 L20.2108 7.2962 C20.8294 7.2961 21.2908 7.4295 21.5948 7.6961 C21.9041 7.9575 22.0588 8.3015 22.0588 8.7281 C22.0588 9.0375 21.9895 9.2828 21.8508 9.4641 C21.7175 9.6455 21.5441 9.7921 21.3308 9.9041 C21.4801 9.9681 21.6295 10.0722 21.7788 10.2161 C21.9281 10.3548 22.0535 10.5201 22.1548 10.7122 C22.2615 10.9042 22.3148 11.1095 22.3148 11.3281 C22.3148 11.6162 22.2374 11.8801 22.0828 12.1201 C21.9335 12.3548 21.7175 12.5441 21.4348 12.6881 C21.1521 12.8268 20.8187 12.8961 20.4348 12.8961 L17.9628 12.8961 Z M19.2268 11.8162 L20.4188 11.8161 C20.6534 11.8161 20.8135 11.7601 20.8988 11.6482 C20.9894 11.5308 21.0348 11.3762 21.0348 11.1841 C21.0348 10.9975 20.9894 10.8482 20.8988 10.7362 C20.8135 10.6188 20.6481 10.5601 20.4028 10.5601 L19.2268 10.5601 L19.2268 11.8162 Z M19.2268 9.4641 L20.0988 9.4642 C20.3494 9.4641 20.5228 9.4241 20.6188 9.3442 C20.7148 9.2588 20.7628 9.1148 20.7627 8.9122 C20.7628 8.7308 20.7174 8.5974 20.6268 8.5122 C20.5361 8.4215 20.3575 8.3762 20.0908 8.3762 L19.2268 8.3761 L19.2268 9.4641 Z",
							id: `${__svgrId}-FEB`,
							style: { fill: "var(--sticker-dark,#5F6F27)" }
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 34`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 9.942,
							x2: 9.942,
							y1: 15.3986,
							y2: 27.0677
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 38`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 13.9199,
							x2: 13.9198,
							y1: 15.3984,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 36`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5944,
							x2: 25.153,
							y1: 19.1321,
							y2: 19.1321
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 37`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5949,
							x2: 25.1535,
							y1: 23.0835,
							y2: 23.0835
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 35`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 17.7503,
							x2: 17.7503,
							y1: 15.3985,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 39`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 21.7954,
							x2: 21.7954,
							y1: 15.3985,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M12.8152 4.3477 L12.8151 6.1461",
							id: `${__svgrId}-Line 40`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#5F6F27)" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M19.2456 4.3477 L19.2456 6.1461",
							id: `${__svgrId}-Line 41`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#5F6F27)" }
						})
					]
				})
			})
		})
	});
};
export default SvgDateFeb;
